import { getLegalUrls } from "./legalUrls";

export type LegalDocumentId = "userAgreement" | "privacyPolicy" | "pdConsent";

export type LegalDocumentItem = {
  id: LegalDocumentId;
  titleRu: string;
  titleEn: string;
  href: string;
  /** Suggested download filename */
  fileName: string;
};

/** Three primary legal PDFs/HTML we always expose in profile & exhibitor cabinet. */
export function getLegalDocumentItems(lang?: string | null): LegalDocumentItem[] {
  const urls = getLegalUrls(lang);
  const isEn = String(lang || "")
    .toLowerCase()
    .startsWith("en");
  return [
    {
      id: "userAgreement",
      titleRu: "Пользовательское соглашение",
      titleEn: "User agreement",
      href: urls.userAgreement,
      fileName: isEn ? "user-agreement.html" : "user-agreement.html",
    },
    {
      id: "privacyPolicy",
      titleRu: "Политика конфиденциальности",
      titleEn: "Privacy policy",
      href: urls.privacyPolicy,
      fileName: isEn ? "privacy-policy.html" : "privacy-policy.html",
    },
    {
      id: "pdConsent",
      titleRu: "Согласие на обработку персональных данных",
      titleEn: "Personal data processing consent",
      href: urls.pdConsent,
      fileName: isEn ? "pd-consent.html" : "pd-consent.html",
    },
  ];
}
